import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { measureFormulaSelector } from '../../../../../redux/selectors/builder';
import { TextButton } from '../../../../../components/Button';
import { addMeasureFormula } from '../../../../../redux/slices/oldBuilder';
import QueryFormulaField from './QueryFormulaField';
import { SvgIcon } from '../../../../../components/Icon';
import { queryFormulaInfo } from '../../../../../components/KubitTooltip/globalTooltips';
import KubitTooltip from '../../../../../components/KubitTooltip';

const QueryFormula = () => {
  const dispatch = useAppDispatch();

  const measureFormula = useAppSelector(measureFormulaSelector);

  const handleAddMeasureFormula = () => {
    dispatch(addMeasureFormula());
  };

  if (!measureFormula) {
    return (
      <KubitTooltip {...queryFormulaInfo} placement="bottom">
        <TextButton onClick={handleAddMeasureFormula}>
          <SvgIcon
            name="function-x"
            width={16}
            height={16}
            customFill="currentColor"
          />
          Formula
        </TextButton>
      </KubitTooltip>
    );
  }

  return (
    <QueryFormulaField
      expression={measureFormula.expression}
      validationError={measureFormula.validationError}
    />
  );
};

export default QueryFormula;
